import { track as cpTrack } from 'cp-analytics';
import { debounce } from 'lodash';

export const track = debounce((event, data) => {
  return cpTrack('practice_management', 'client_portal', event, data);
}, 300)
